<div class="p-3">
  <div class="d-flex flex-wrap align-items-center filtros">
    <label class="mb-0 me-2">Llamadas a la IA</label>
    <mat-form-field subscriptSizing="dynamic" class="fecha-field">
      <mat-label>Desde</mat-label>
      <input matInput type="date" [(ngModel)]="desde" [disabled]="isLoading">
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic" class="fecha-field">
      <mat-label>Hasta</mat-label>
      <input matInput type="date" [(ngModel)]="hasta" [disabled]="isLoading">
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic" class="origen-field">
      <mat-label>Origen</mat-label>
      <mat-select [(ngModel)]="origen" (selectionChange)="cargarLlamadas()" [disabled]="isLoading">
        <mat-option value="">Todos</mat-option>
        <mat-option *ngFor="let o of porOrigen" [value]="o.origen">{{ o.origen }}</mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-raised-button color="primary" (click)="cargar()" [disabled]="isLoading">
      <mat-icon>refresh</mat-icon>
      Consultar
    </button>
  </div>

  <div *ngIf="isLoading" class="my-2">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <div *ngIf="!precioActual" class="aviso my-2">
    <mat-icon>warning</mat-icon>
    El modelo en uso ({{ modeloActual }}) no tiene precio: sus llamadas se guardan sin coste. Ponlo en "Precios" más abajo.
  </div>

  <!-- Totales del rango -->
  <div class="tarjetas my-3" *ngIf="totales">
    <div class="tarjeta">
      <span class="valor">{{ totales.llamadas | number }}</span>
      <span class="etiqueta">Llamadas</span>
    </div>
    <div class="tarjeta">
      <span class="valor" [class.text-danger]="totales.errores > 0">{{ totales.errores | number }}</span>
      <span class="etiqueta">Errores</span>
      <span class="nota" *ngIf="totales.incompletas">{{ totales.incompletas }} cortadas o vacías</span>
    </div>
    <div class="tarjeta">
      <span class="valor">{{ totales.total_tokens | number }}</span>
      <span class="etiqueta">Tokens</span>
      <span class="nota">{{ totales.prompt_tokens | number }} entrada · {{ totales.completion_tokens | number }} salida</span>
    </div>
    <div class="tarjeta">
      <span class="valor">{{ totales.coste_usd !== null ? ('$' + (totales.coste_usd | number:'1.2-4')) : '—' }}</span>
      <span class="etiqueta">Coste USD</span>
      <span class="nota" *ngIf="totales.sin_coste">{{ totales.sin_coste }} sin precio</span>
    </div>
    <div class="tarjeta">
      <span class="valor">{{ totales.ms_medio !== null ? ((totales.ms_medio / 1000) | number:'1.1-1') + ' s' : '—' }}</span>
      <span class="etiqueta">Tiempo medio</span>
      <span class="nota" *ngIf="totales.ms_p95 !== null">p95 {{ (totales.ms_p95 / 1000) | number:'1.1-1' }} s</span>
    </div>
  </div>

  <!-- Por origen -->
  <h6 class="mt-3">Por origen</h6>
  <div class="tabla-scroll">
    <table class="table table-sm tabla-ia" *ngIf="porOrigen.length; else sinDatos">
      <thead>
        <tr>
          <th>Origen</th><th class="num">Llamadas</th><th class="num">Errores</th>
          <th class="num">Entrada</th><th class="num">Cacheados</th><th class="num">Salida</th><th class="num">Razonamiento</th>
          <th class="num">Coste USD</th><th class="num">Medio</th><th class="num">p95</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let o of porOrigen">
          <td>{{ o.origen }}</td>
          <td class="num">{{ o.llamadas | number }}</td>
          <td class="num" [class.text-danger]="o.errores > 0">{{ o.errores | number }}</td>
          <td class="num">{{ o.prompt_tokens | number }}</td>
          <td class="num">{{ o.cached_tokens | number }}</td>
          <td class="num">{{ o.completion_tokens | number }}</td>
          <td class="num">{{ o.reasoning_tokens | number }}</td>
          <td class="num">{{ o.coste_usd !== null ? (o.coste_usd | number:'1.4-4') : '—' }}</td>
          <td class="num">{{ o.ms_medio !== null ? ((o.ms_medio / 1000) | number:'1.1-1') + ' s' : '—' }}</td>
          <td class="num">{{ o.ms_p95 !== null ? ((o.ms_p95 / 1000) | number:'1.1-1') + ' s' : '—' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Últimas llamadas -->
  <h6 class="mt-3">Últimas llamadas <small class="text-muted">(pulsa una fila para ver el prompt y la respuesta)</small></h6>
  <div class="tabla-scroll">
    <table class="table table-sm tabla-ia" *ngIf="llamadas.length; else sinDatos">
      <thead>
        <tr>
          <th>Fecha</th><th>Origen</th><th>Usuario</th><th>Estado</th>
          <th class="num">Tiempo</th><th class="num">Entrada</th><th class="num">Salida</th><th class="num">Razonamiento</th><th class="num">Coste USD</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let l of llamadas">
          <tr class="fila-llamada" [class.seleccionada]="seleccionada?.id === l.id" (click)="verDetalle(l)">
            <td>{{ l.fecha | date:'yyyy-MM-dd HH:mm:ss' }}</td>
            <td>{{ l.origen }}</td>
            <td>{{ l.email || (l.idusuario ? '#' + l.idusuario : 'anónimo') }}</td>
            <td><span class="estado" [ngClass]="'estado-' + l.estado">{{ l.estado }}</span></td>
            <td class="num">{{ (l.duracion_ms / 1000) | number:'1.1-1' }} s</td>
            <td class="num">{{ l.prompt_tokens | number }}</td>
            <td class="num">{{ l.completion_tokens | number }}</td>
            <td class="num">{{ l.reasoning_tokens | number }}</td>
            <td class="num">{{ l.coste_usd !== null ? (l.coste_usd | number:'1.4-6') : '—' }}</td>
          </tr>
          <tr *ngIf="seleccionada?.id === l.id" class="fila-detalle">
            <td colspan="9">
              <div *ngIf="!detalle" class="text-muted small">Cargando…</div>
              <ng-container *ngIf="detalle">
                <div class="small text-muted mb-1">{{ l.modelo }} · reasoning {{ l.reasoning_effort }} · finish {{ l.finish_reason || '—' }} · {{ l.cached_tokens | number }} cacheados</div>
                <div *ngIf="detalle.error" class="text-danger small mb-2">{{ detalle.error }}</div>
                <div class="detalle-textos">
                  <div>
                    <div class="detalle-titulo">Prompt (último mensaje del usuario)</div>
                    <pre>{{ detalle.prompt_recortado || '—' }}</pre>
                  </div>
                  <div>
                    <div class="detalle-titulo">Respuesta</div>
                    <pre>{{ detalle.respuesta_recortada || '—' }}</pre>
                  </div>
                </div>
              </ng-container>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <!-- Precios -->
  <h6 class="mt-4">Precios por millón de tokens (USD)</h6>
  <p class="small text-muted mb-2">El coste de cada llamada se calcula con el precio vigente en ese momento; cambiarlo no recalcula las anteriores.</p>
  <table class="table table-sm tabla-ia tabla-precios" *ngIf="precios.length">
    <thead>
      <tr><th>Modelo</th><th>Entrada</th><th>Entrada cacheada</th><th>Salida</th><th>Actualizado</th><th></th></tr>
    </thead>
    <tbody>
      <tr *ngFor="let p of precios">
        <td>{{ p.modelo }} <span *ngIf="p.modelo === modeloActual" class="text-muted small">(en uso)</span></td>
        <td><input class="form-control form-control-sm precio-input" type="number" min="0" step="0.01" [(ngModel)]="p.entrada_por_millon"></td>
        <td><input class="form-control form-control-sm precio-input" type="number" min="0" step="0.01" [(ngModel)]="p.cacheada_por_millon"></td>
        <td><input class="form-control form-control-sm precio-input" type="number" min="0" step="0.01" [(ngModel)]="p.salida_por_millon"></td>
        <td class="small">{{ p.actualizado ? (p.actualizado | date:'yyyy-MM-dd HH:mm') : 'sin precio' }}</td>
        <td>
          <button mat-stroked-button (click)="guardarPrecio(p)" [disabled]="!precioValido(p) || !!guardandoPrecio">
            <mat-icon>save</mat-icon>
            Guardar
          </button>
        </td>
      </tr>
    </tbody>
  </table>

  <ng-template #sinDatos>
    <div class="text-muted small">Sin llamadas en este rango.</div>
  </ng-template>
</div>
